import axiosInstance from '@/core/api'
import {
	AdminPartnerDailyTransactionsRequest,
	AdminPartnerDailyTransactionsResponse,
	AdminPartnerInvitationSummaryRequest,
	AdminPartnerInvitationSummaryResponse,
	CreateChannelRequest,
	CreateChannelResponse,
	CreatePartnerResponse,
	CreatePartnerRequest,
	CreatePlayerRequest,
	CreatePlayerResponse,
	GetBannedPlayerRequest,
	GetBannedPlayerResponse,
	GetChannelRequest,
	GetChannelResponse,
	GetInactivePlayerResponse,
	GetInactivePlyerRequest,
	GetMinimumWithdrawSettingResponse,
	GetPartnerResponse,
	GetPartnerRequest,
	GetPlayerListRequest,
	GetPlayerListResponse,
	UpdatePartnerResponse,
	UpdateChannelRequest,
	UpdateChannelResponse,
	UpdateMinimumWithdrawSettingRequest,
	UpdateMinimumWithdrawSettingResponse,
	UpdatePlayerRequest,
	UpdatePlayerResponse,
	UpdatePartnerRequest,
	GetPartnerByIdResponse,
	GetPlayerClearTurnoverHistoryRequest,
	GetPlayerClearTurnoverHistoryResponse,
	GetPlayerTransactionsByIdRequest,
	GetPlayerTransactionsByIdResponse,
	GetPlayerPlaylogResponse,
	GetPlayerPlaylogRequest,
	GetReferredPlayersRequest,
	GetReferredPlayersResponse,
	GetInviteFriendReferredPlayersRequest,
	GetInviteFriendReferredPlayersResponse,
	GetPlayerCumulativeResponse,
	GetInviteFriendTierCountsResponse,
	GetPlayerDetailResponse,
	GetPlayerFullPhoneResponse,
	GetActivePlayerRequest,
	GetActivePlayerResponse,
	GetPlayerWithDepositRequest,
	GetPlayerWithDepositResponse,
	GetPlayerWithDepositPromotionRequest,
	GetPlayerWithDepositPromotionResponse,
	GetPlayerWithDepositsWithoutPromotionRequest,
	GetPlayerWithDepositsWithoutPromotionResponse,
	GetPlayerActivityLogRequest,
	GetPlayerActivityLogResponse,
	ClearPlayerTurnoverRequest,
	ClearPlayerTurnoverResponse,
	UpdatePlayerMainWalletBalanceRequest,
	UpdatePlayerMainWalletBalanceResponse,
	GetPlayerWithWithdrawResponse,
	GetPlayerWithWithdrawRequest,
	GetPlayerWithLuckyWheelReceiveRequest,
	GetPlayerWithLuckyWheelReceiveResponse,
	GetPlayWithReturnLossReceiveRequest,
	GetPlayWithReturnLossReceiveResponse,
	GetPlayerWithDailyCheckInRequest,
	GetPlayerWithDailyCheckInResponse,
	GetPlayerDataListRequest,
	GetPlayerDataListResponse,
	GetRegisteredPlayerRequest,
	GetRegisteredPlayerResponse,
	ExportPlayersWithDepositPromotionCsvRequest,
	ExportPlayerActivityLogCsvRequest,
	ExportPlayerClearTurnoverHistoryCsvRequest,
	ExportReferredPlayersCsvRequest,
	ExportPlayerPlaylogCsvRequest,
	ExportPlayerTransactionsCsvRequest,
	ExportPlayerListCsvRequest,
	ExportPlayerWithDepositCsvRequest,
	GetPartnerPlayersRequest,
	GetPartnerPlayersResponse,
	GetPartnerPlayersSummaryRequest,
	GetPartnerPlayersSummaryResponse,
	ExportPartnerPlayersCsvRequest,
	GetPlayerProviderStatsRequest,
	GetPlayerProviderStatsResponse,
	GetPlayerCommissionAdminResponse,
	GetPlayerReturnLossAdminResponse,
	GetPartnerPaymentRecordsResponse,
	PartnerPaymentRecordModel,
	CreatePartnerPaymentRecordRequest,
	CreatePartnerPaymentRecordResponse,
	ReinitPlayerPlaylogResponse,
	ExportPlayerDataListCsvRequest,
} from '../../type'

export const getPlayerList = async (
	payload: GetPlayerListRequest,
): Promise<GetPlayerListResponse> => {
	const response = await axiosInstance.get<GetPlayerListResponse>(
		`/admin/operators/players/get-players`,
		{
			params: payload,
		},
	)
	return response.data
}

export const getChannelList = async (
	payload: GetChannelRequest,
): Promise<GetChannelResponse> => {
	const response = await axiosInstance.get<GetChannelResponse>(
		`/admin/operators/channels/get-channels`,
		{
			params: payload,
		},
	)
	return response.data
}

export const createPlayer = async (
	payload: CreatePlayerRequest,
): Promise<CreatePlayerResponse> => {
	const response = await axiosInstance.post<CreatePlayerResponse>(
		`/admin/operators/players/create-player`,
		payload,
	)
	return response.data
}

export const updatePlayer = async (
	id: string,
	payload: UpdatePlayerRequest,
): Promise<UpdatePlayerResponse> => {
	const response = await axiosInstance.patch<UpdatePlayerResponse>(
		`/admin/operators/players/update-player/${id}`,
		payload,
	)
	return response.data
}

export const deletePlayer = async (id: string): Promise<void> => {
	const response = await axiosInstance.delete<void>(
		`/admin/operators/players/delete-player/${id}`,
	)
	return response.data
}

export const createChannel = async (
	payload: CreateChannelRequest,
): Promise<CreateChannelResponse> => {
	const response = await axiosInstance.post<CreateChannelResponse>(
		`/admin/operators/channels/create-channel`,
		payload,
	)
	return response.data
}

export const updateChannel = async (
	id: string,
	payload: UpdateChannelRequest,
): Promise<UpdateChannelResponse> => {
	const response = await axiosInstance.patch<UpdateChannelResponse>(
		`/admin/operators/channels/update-channel/${id}`,
		payload,
	)
	return response.data
}

export const deleteChannel = async (id: string): Promise<void> => {
	const response = await axiosInstance.delete<void>(
		`/admin/operators/channels/delete-channel/${id}`,
	)
	return response.data
}

export const getBannedPlayerList = async (
	payload: GetBannedPlayerRequest,
): Promise<GetBannedPlayerResponse> => {
	const response = await axiosInstance.get<GetBannedPlayerResponse>(
		`/admin/operators/players/banned-players`,
		{
			params: payload,
		},
	)
	return response.data
}

export const getInactivePlayerList = async (
	payload: GetInactivePlyerRequest,
): Promise<GetInactivePlayerResponse> => {
	const response = await axiosInstance.get<GetInactivePlayerResponse>(
		`/admin/operators/players/inactive-players`,
		{
			params: payload,
		},
	)
	return response.data
}

export const getMinimumWithdrawSetting =
	async (): Promise<GetMinimumWithdrawSettingResponse> => {
		const response = await axiosInstance.get<GetMinimumWithdrawSettingResponse>(
			`/admin/minimum-withdraw`,
		)
		return response.data
	}

export const updateMinimumWithdrawSetting = async (
	payload: UpdateMinimumWithdrawSettingRequest,
): Promise<UpdateMinimumWithdrawSettingResponse> => {
	const response =
		await axiosInstance.patch<UpdateMinimumWithdrawSettingResponse>(
			`/admin/minimum-withdraw`,
			payload,
		)
	return response.data
}

export const getPartners = async (
	payload: GetPartnerRequest,
): Promise<GetPartnerResponse> => {
	const response = await axiosInstance.get<GetPartnerResponse>(
		`/admin/operators/partners/get-partners`,
		{
			params: payload,
		},
	)
	return response.data
}

export const createPartner = async (
	payload: CreatePartnerRequest,
): Promise<CreatePartnerResponse> => {
	const response = await axiosInstance.post<CreatePartnerResponse>(
		`/admin/operators/partners/create-partner`,
		payload,
	)
	return response.data
}

export const updatePartner = async (
	id: string,
	payload: UpdatePartnerRequest,
): Promise<UpdatePartnerResponse> => {
	const response = await axiosInstance.patch<UpdatePartnerResponse>(
		`/admin/operators/partners/update-partner/${id}`,
		payload,
	)
	return response.data
}

export const getPartnerById = async (
	id: string,
): Promise<GetPartnerByIdResponse> => {
	const response = await axiosInstance.get<GetPartnerByIdResponse>(
		`/admin/operators/partners/get-partner/${id}`,
	)
	return response.data
}

export interface AddCreditToPartnerRequest {
	amount: number
	note?: string
}

export const addCreditToPartner = async (
	partnerId: string,
	payload: AddCreditToPartnerRequest,
): Promise<GetPartnerByIdResponse> => {
	const response = await axiosInstance.post<GetPartnerByIdResponse>(
		`/admin/operators/partners/${partnerId}/add-credit`,
		payload,
	)
	return response.data
}

export const clearPlayerLockout = async (phone: string): Promise<void> => {
	await axiosInstance.post(`/admin/operators/players/clear-lockout`, {
		phone,
	})
}

export const getPlayerClearTurnoverHistory = async (
	payload: GetPlayerClearTurnoverHistoryRequest,
): Promise<GetPlayerClearTurnoverHistoryResponse> => {
	const response =
		await axiosInstance.get<GetPlayerClearTurnoverHistoryResponse>(
			`/admin/operators/players/clear-turnover-history`,
			{
				params: payload,
			},
		)
	return response.data
}
export const getPlayerTransactionsById = async (
	payload: GetPlayerTransactionsByIdRequest,
): Promise<GetPlayerTransactionsByIdResponse> => {
	const response = await axiosInstance.get<GetPlayerTransactionsByIdResponse>(
		`/admin/operators/players/transactions`,
		{
			params: payload,
		},
	)
	return response.data
}

export const getPlayerPlaylog = async (
	playerId: string,
	payload: GetPlayerPlaylogRequest,
): Promise<GetPlayerPlaylogResponse> => {
	const response = await axiosInstance.get<GetPlayerPlaylogResponse>(
		`/admin/operators/players/playlog/${playerId}`,
		{
			params: payload,
		},
	)
	return response.data
}

export const reinitPlayerPlaylog = async (
	playerId: string,
	initSessionLogId: string,
): Promise<ReinitPlayerPlaylogResponse> => {
	const response = await axiosInstance.post<ReinitPlayerPlaylogResponse>(
		`/admin/operators/players/playlog-reinit/${playerId}`,
		{ initSessionLogId },
	)
	return response.data
}

export const getReferredPlayers = async (
	playerId: string,
	payload: GetReferredPlayersRequest,
): Promise<GetReferredPlayersResponse> => {
	const response = await axiosInstance.get<GetReferredPlayersResponse>(
		`/admin/operators/players/referred/${playerId}`,
		{
			params: payload,
		},
	)
	return response.data
}

export const getInviteFriendReferredPlayers = async (
	playerId: string,
	payload: GetInviteFriendReferredPlayersRequest,
): Promise<GetInviteFriendReferredPlayersResponse> => {
	const response =
		await axiosInstance.get<GetInviteFriendReferredPlayersResponse>(
			`/admin/invite-friend/referred-players/${playerId}`,
			{
				params: payload,
			},
		)
	return response.data
}

export const getPlayerCumulative = async (
	playerId: string,
): Promise<GetPlayerCumulativeResponse> => {
	const response = await axiosInstance.get<GetPlayerCumulativeResponse>(
		`/admin/operators/players/cumulative/${playerId}`,
	)
	return response.data
}

export const getPlayerCommission = async (
	playerId: string,
): Promise<GetPlayerCommissionAdminResponse> => {
	const response = await axiosInstance.get<GetPlayerCommissionAdminResponse>(
		`/admin/operators/players/commission/${playerId}`,
	)
	return response.data
}

export const getPlayerReturnLoss = async (
	playerId: string,
): Promise<GetPlayerReturnLossAdminResponse> => {
	const response = await axiosInstance.get<GetPlayerReturnLossAdminResponse>(
		`/admin/operators/players/return-loss/${playerId}`,
	)
	return response.data
}

export const getInviteFriendTierCounts = async (
	playerId: string,
): Promise<GetInviteFriendTierCountsResponse> => {
	const response = await axiosInstance.get<GetInviteFriendTierCountsResponse>(
		`/admin/invite-friend/tier-counts/${playerId}`,
	)
	return response.data
}

export const getPlayerDetail = async (
	id: string,
): Promise<GetPlayerDetailResponse> => {
	const response = await axiosInstance.get<GetPlayerDetailResponse>(
		`/admin/operators/players/get-player/${id}`,
	)
	return response.data
}

export const getPlayerFullPhone = async (
	id: string,
): Promise<GetPlayerFullPhoneResponse> => {
	const response = await axiosInstance.get<GetPlayerFullPhoneResponse>(
		`/admin/operators/players/get-player-full-phone/${id}`,
	)
	return response.data
}

export const getActivePlayer = async (
	payload: GetActivePlayerRequest,
): Promise<GetActivePlayerResponse> => {
	const response = await axiosInstance.get<GetActivePlayerResponse>(
		`/admin/operators/players/active-players`,
		{
			params: payload,
		},
	)
	return response.data
}

export const getPlayerActivityLog = async (
	payload: GetPlayerActivityLogRequest,
): Promise<GetPlayerActivityLogResponse> => {
	const { body, ...queryParams } = payload
	const response = await axiosInstance.post<GetPlayerActivityLogResponse>(
		`/admin/operators/players/activity-log`,
		body || {},
		{
			params: queryParams,
		},
	)
	return response.data
}

export const getPlayerWithDeposit = async (
	payload: GetPlayerWithDepositRequest,
): Promise<GetPlayerWithDepositResponse> => {
	const response = await axiosInstance.get<GetPlayerWithDepositResponse>(
		`/admin/operators/players/players-with-deposits`,
		{
			params: payload,
		},
	)
	return response.data
}

export const getPlayerWithDepositPromotion = async (
	payload: GetPlayerWithDepositPromotionRequest,
): Promise<GetPlayerWithDepositPromotionResponse> => {
	const response =
		await axiosInstance.get<GetPlayerWithDepositPromotionResponse>(
			`/admin/operators/players/players-with-deposit-promotion`,
			{
				params: payload,
			},
		)
	return response.data
}

export const getPlayerWithDepositsWithoutPromotion = async (
	payload: GetPlayerWithDepositsWithoutPromotionRequest,
): Promise<GetPlayerWithDepositsWithoutPromotionResponse> => {
	const response =
		await axiosInstance.get<GetPlayerWithDepositsWithoutPromotionResponse>(
			`/admin/operators/players/players-with-deposits-without-promotion`,
			{
				params: payload,
			},
		)
	return response.data
}

export const clearPlayerTurnover = async (
	payload: ClearPlayerTurnoverRequest,
): Promise<ClearPlayerTurnoverResponse> => {
	const response = await axiosInstance.post<ClearPlayerTurnoverResponse>(
		`/admin/operators/players/clear-turnover`,
		payload,
	)
	return response.data
}

export const clearPlayerMainWalletTurnover = async (
	payload: ClearPlayerTurnoverRequest,
): Promise<ClearPlayerTurnoverResponse> => {
	const response = await axiosInstance.post<ClearPlayerTurnoverResponse>(
		`/admin/operators/players/clear-main-wallet-turnover`,
		payload,
	)
	return response.data
}

export const updatePlayerMainWalletBalance = async (
	payload: UpdatePlayerMainWalletBalanceRequest,
): Promise<UpdatePlayerMainWalletBalanceResponse> => {
	const response =
		await axiosInstance.patch<UpdatePlayerMainWalletBalanceResponse>(
			`/admin/operators/players/update-main-wallet-balance`,
			payload,
		)
	return response.data
}

export const getPlayerWithWithdraw = async (
	payload: GetPlayerWithWithdrawRequest,
): Promise<GetPlayerWithWithdrawResponse> => {
	const response = await axiosInstance.get<GetPlayerWithWithdrawResponse>(
		`/admin/operators/players/players-with-withdraws`,
		{
			params: payload,
		},
	)
	return response.data
}

export const getPlayerWithLuckyWheelReceive = async (
	payload: GetPlayerWithLuckyWheelReceiveRequest,
): Promise<GetPlayerWithLuckyWheelReceiveResponse> => {
	const response =
		await axiosInstance.get<GetPlayerWithLuckyWheelReceiveResponse>(
			`/admin/operators/players/players-with-lucky-wheel-receive`,
			{
				params: payload,
			},
		)
	return response.data
}

export const getPlayerWithReturnLossReceive = async (
	payload: GetPlayWithReturnLossReceiveRequest,
): Promise<GetPlayWithReturnLossReceiveResponse> => {
	const response =
		await axiosInstance.get<GetPlayWithReturnLossReceiveResponse>(
			`/admin/operators/players/players-with-return-loss-receive`,
			{
				params: payload,
			},
		)
	return response.data
}

export const getPlayerWithDailyCheckInReceive = async (
	payload: GetPlayerWithDailyCheckInRequest,
): Promise<GetPlayerWithDailyCheckInResponse> => {
	const response = await axiosInstance.get<GetPlayerWithDailyCheckInResponse>(
		`/admin/operators/players/players-with-daily-check-in-receive`,
		{
			params: payload,
		},
	)
	return response.data
}

export const getPlayerDataList = async (
	payload: GetPlayerDataListRequest,
): Promise<GetPlayerDataListResponse> => {
	const response = await axiosInstance.get<GetPlayerDataListResponse>(
		`/admin/operators/players/player-data-list`,
		{
			params: payload,
		},
	)
	return response.data
}

export const getRegisteredPlayerList = async (
	payload: GetRegisteredPlayerRequest,
): Promise<GetRegisteredPlayerResponse> => {
	const response = await axiosInstance.get<GetRegisteredPlayerResponse>(
		`/admin/operators/players/registered-players`,
		{
			params: payload,
		},
	)
	return response.data
}

export const exportPlayersWithDepositPromotionCsv = async (
	payload: ExportPlayersWithDepositPromotionCsvRequest,
): Promise<Blob> => {
	const response = await axiosInstance.post(
		`/admin/operators/players/players-with-deposit-promotion-csv`,
		payload,
		{
			responseType: 'blob',
		},
	)
	return response.data
}

export const exportPlayerTransactionsCsv = async (
	payload: ExportPlayerTransactionsCsvRequest,
): Promise<Blob> => {
	const response = await axiosInstance.post(
		`/admin/operators/players/transactions-csv`,
		payload,
		{
			responseType: 'blob',
		},
	)
	return response.data
}

export const exportPlayerPlaylogCsv = async (
	payload: ExportPlayerPlaylogCsvRequest,
): Promise<Blob> => {
	const { playerId, ...rest } = payload
	const response = await axiosInstance.post(
		`/admin/operators/players/playlog-csv/${playerId}`,
		rest,
		{
			responseType: 'blob',
		},
	)
	return response.data
}

export const exportReferredPlayersCsv = async (
	payload: ExportReferredPlayersCsvRequest,
): Promise<Blob> => {
	const { playerId, ...rest } = payload
	const response = await axiosInstance.post(
		`/admin/operators/players/referred-csv/${playerId}`,
		rest,
		{
			responseType: 'blob',
		},
	)
	return response.data
}

export const exportPlayerClearTurnoverHistoryCsv = async (
	payload: ExportPlayerClearTurnoverHistoryCsvRequest,
): Promise<Blob> => {
	const response = await axiosInstance.post(
		`/admin/operators/players/clear-turnover-history-csv`,
		payload,
		{
			responseType: 'blob',
		},
	)
	return response.data
}

export const exportPlayerActivityLogCsv = async (
	payload: ExportPlayerActivityLogCsvRequest,
): Promise<Blob> => {
	const response = await axiosInstance.post(
		`/admin/operators/players/activity-log-csv`,
		payload,
		{
			responseType: 'blob',
		},
	)
	return response.data
}

export const exportPlayerListCsv = async (
	payload: ExportPlayerListCsvRequest,
): Promise<Blob> => {
	const response = await axiosInstance.post(
		`/admin/operators/players/get-players-csv`,
		payload,
		{
			responseType: 'blob',
		},
	)
	return response.data
}

export const exportPlayerWithDepositCsv = async (
	payload: ExportPlayerWithDepositCsvRequest,
): Promise<Blob> => {
	const response = await axiosInstance.post(
		`/admin/operators/players/players-with-deposits-csv`,
		payload,
		{
			responseType: 'blob',
		},
	)
	return response.data
}

export const exportPlayerDataListCsv = async (
	payload: ExportPlayerDataListCsvRequest,
): Promise<Blob> => {
	const response = await axiosInstance.post(
		`/admin/operators/players/player-data-list-csv`,
		payload,
		{
			responseType: 'blob',
		},
	)
	return response.data
}

// Partner Players API
export const getPartnerPlayers = async (
	partnerId: string,
	payload: GetPartnerPlayersRequest,
): Promise<GetPartnerPlayersResponse> => {
	const response = await axiosInstance.get<GetPartnerPlayersResponse>(
		`/admin/operators/partners/${partnerId}/players`,
		{
			params: payload,
		},
	)
	return response.data
}

// Partner Players Summary API (separate from pagination)
export const getPartnerPlayersSummary = async (
	partnerId: string,
	payload: GetPartnerPlayersSummaryRequest,
): Promise<GetPartnerPlayersSummaryResponse> => {
	const response = await axiosInstance.get<GetPartnerPlayersSummaryResponse>(
		`/admin/operators/partners/${partnerId}/players/summary`,
		{
			params: payload,
		},
	)
	return response.data
}

export const exportPartnerPlayersCsv = async (
	partnerId: string,
	payload: ExportPartnerPlayersCsvRequest,
): Promise<Blob> => {
	const response = await axiosInstance.post(
		`/admin/operators/partners/${partnerId}/players/export-csv`,
		payload,
		{
			responseType: 'blob',
		},
	)
	return response.data
}

export const getPlayerProviderStats = async (
	payload: GetPlayerProviderStatsRequest,
): Promise<GetPlayerProviderStatsResponse> => {
	const response = await axiosInstance.get<GetPlayerProviderStatsResponse>(
		`/admin/operators/players/provider-stats`,
		{
			params: payload,
		},
	)
	return response.data
}

// Partner Payment Records
export const getPartnerPaymentRecords = async (
	partnerId: string,
	payload?: { skip?: number; take?: number },
): Promise<GetPartnerPaymentRecordsResponse> => {
	const response = await axiosInstance.get<GetPartnerPaymentRecordsResponse>(
		`/admin/operators/partners/${partnerId}/payment-records`,
		{
			params: payload,
		},
	)
	return response.data
}

export const getPartnerPaymentRecordById = async (
	partnerId: string,
	recordId: string,
): Promise<PartnerPaymentRecordModel> => {
	const response = await axiosInstance.get<PartnerPaymentRecordModel>(
		`/admin/operators/partners/${partnerId}/payment-records/${recordId}`,
	)
	return response.data
}

export const createPartnerPaymentRecord = async (
	partnerId: string,
	payload: CreatePartnerPaymentRecordRequest,
): Promise<CreatePartnerPaymentRecordResponse> => {
	const response = await axiosInstance.post<CreatePartnerPaymentRecordResponse>(
		`/admin/operators/partners/${partnerId}/payment-records`,
		payload,
	)
	return response.data
}

export const getAdminPartnerDailyTransactions = async (
	partnerId: string,
	payload?: AdminPartnerDailyTransactionsRequest,
): Promise<AdminPartnerDailyTransactionsResponse> => {
	const response =
		await axiosInstance.get<AdminPartnerDailyTransactionsResponse>(
			`/admin/operators/partners/${partnerId}/analytics/daily-transactions`,
			{ params: payload },
		)
	return response.data
}

export const getAdminPartnerInvitationSummary = async (
	partnerId: string,
	payload?: AdminPartnerInvitationSummaryRequest,
): Promise<AdminPartnerInvitationSummaryResponse> => {
	const response =
		await axiosInstance.get<AdminPartnerInvitationSummaryResponse>(
			`/admin/operators/partners/${partnerId}/analytics/invitation-summary`,
			{ params: payload },
		)
	return response.data
}

export type ToggleDemoAccountRequest = {
	playerId: string
}

export type ToggleDemoAccountResponse = {
	id: string
	isAgentDemoAccount: boolean
}

export const toggleDemoAccount = async (
	payload: ToggleDemoAccountRequest,
): Promise<ToggleDemoAccountResponse> => {
	const response = await axiosInstance.post<ToggleDemoAccountResponse>(
		`/admin/operators/players/toggle-demo-account`,
		payload,
	)
	return response.data
}
